import { Text } from '@dapperlabs/core-fe';
import { StarsIcon } from 'src/theme/Icon';

interface Props {
  label: string;
}

export const GuaranteeLabel = ({ label }: Props) => (
  <Text
    alignItems='center'
    display='flex'
    mt={2}
    mb={4}
    px={1}
    py={1}
    color='#FFF'
    fontFamily='mono'
    fontSize='sm'
    background='black'
    opacity='80%'
    borderRadius='6px'
  >
    <StarsIcon sx={{ path: { fill: '#fff' } }} mr={1} />
    <Text as='span'>{label}</Text>
  </Text>
);
